import { render } from "./bottom.vue?vue&type=template&id=9a801e98&scoped=true"
import script from "./bottom.vue?vue&type=script&lang=js"
export * from "./bottom.vue?vue&type=script&lang=js"

import "../../public/static/css/app.css?vue&type=style&index=0&id=9a801e98&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a801e98"]])

export default __exports__